import styled from 'styled-components';
import useAuthenticationSettingTabs from './useAuthenticationSettingTabs';
import RouterTabs from 'components/RouterTabs';
import { StyledTabs } from 'components/RouterTabs/RouterTabs.style';
import { SPACES } from 'common/constants/sizes';

const StyledAuthenticationSettingRouter = styled.div`
  & ${StyledTabs} {
    padding-top: ${SPACES.medium};
  }
`;

const AuthenticationSettingRouter = () => {
  const tabs = useAuthenticationSettingTabs();

  return (
    <StyledAuthenticationSettingRouter>
      <RouterTabs tabs={tabs} withTabs={tabs.length > 1} />
    </StyledAuthenticationSettingRouter>
  );
};

export default AuthenticationSettingRouter;
